// extracted by mini-css-extract-plugin
export default {"bentoGrid":"BentoGrid_bentoGrid__QoGcS"};